import { Charts } from './Charts';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const IncreaseInValuesWrapper = () => {
    return (
        <ServicesChartsDataProvider>
            <Charts />
        </ServicesChartsDataProvider>
    );
};

export default IncreaseInValuesWrapper;
